import { ContentBox } from 'app/agriculture/components/ContentBox/ContentBox';
import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplaySkeleton } from 'app/agriculture/components/StatDisplay/StatDisplaySkeleton';

export function PowerDisplaySkeleton() {
    return (
        <ContentBox.Section heading="Power Stats" disableDivider>
            <SimpleGrid className="PowerDisplay" columns={3}>
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
                <StatDisplaySkeleton />
            </SimpleGrid>
        </ContentBox.Section>
    );
}
